import { customerBaseApi } from "@/react/services/api/api";
import { HttpMethods } from "@/react/http";

const ADDRESSES = "addresses";
const addressManagementBaseUrl = "address-management";

export const customerAddressesApi = customerBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    retrieveAddressesByCustomer: builder.query({
      query: () => ({
        url: addressManagementBaseUrl,
        method: HttpMethods.GET,
      }),
      transformResponse: (response) => {
        const resultMap = {};
        for (const item of response) {
          resultMap[item.id] = item;
        }
        return resultMap;
      },
      providesTags: [ADDRESSES],
    }),
    getAddressById: builder.query({
      query: ({ addressId }) => ({
        url: `${addressManagementBaseUrl}/${addressId}`,
        method: HttpMethods.GET,
      }),
    }),
    searchAddress: builder.query({
      query: ({ address }) => ({
        url: `${addressManagementBaseUrl}/search`,
        method: HttpMethods.POST,
        body: address,
      }),
    }),
    createAddress: builder.mutation({
      query: ({ address }) => ({
        url: addressManagementBaseUrl,
        method: HttpMethods.POST,
        body: address,
      }),
    }),
  }),
});

export const {
  useRetrieveAddressesByCustomerQuery,
  useLazyGetAddressByIdQuery,
  useLazySearchAddressQuery,
  useCreateAddressMutation,
} = customerAddressesApi;
